import {
  CHANGE_FILE,
  CLOSE_PLAYER,
  PAUSE, PLAY, SET_PLAYER,
} from "@/actions/types";
import {PLAYERSTATUS} from "@/constants";

export default function (state = {}, action: {type: string, payload: {post: IPostItem | IPostDetails, file: IFileItem, player: HTMLAudioElement | undefined}}) {
  const { type, payload } = action;

  switch (type) {
    case PLAY:
      return {
        ...state,
        status: PLAYERSTATUS.PLAYING,
        file: payload.file,
        post: payload.post
      };
    case CHANGE_FILE:
      return {
        ...state,
        file: payload.file
      };
    case PAUSE:
      return {
        ...state,
        status: PLAYERSTATUS.PAUSED,
      };
    case CLOSE_PLAYER:
      return {
        ...state,
        status: PLAYERSTATUS.CLOSED,
      };
    case SET_PLAYER:
      return {
        ...state,
        player: payload.player
      };
    case PLAYERSTATUS.PLAYING:
      return {
        ...state,
        status: PLAYERSTATUS.PLAYING,
      };
    case PLAYERSTATUS.PAUSED:
      return {
        ...state,
        status: PLAYERSTATUS.PAUSED,
      };
    case PLAYERSTATUS.REPEAT:
      return {
        ...state,
        status: PLAYERSTATUS.REPEAT,
      };
    case PLAYERSTATUS.LOADING:
      return {
        ...state,
        status: PLAYERSTATUS.LOADING,
      };
    case PLAYERSTATUS.TEMP_PAUSE:
      return {
        ...state,
        status: PLAYERSTATUS.TEMP_PAUSE,
      };
    default:
      return state;
  }
}
